import diagramCatalog from "../../data/diagram-gallery.json";

export interface DiagramEntry {
  readonly id: string;
  readonly name: string;
  readonly category: string;
  readonly location: string;
}

export interface DiagramCategoryStats {
  readonly categories: readonly string[];
  readonly counts: ReadonlyMap<string, number>;
}

export const DIAGRAM_GALLERY: readonly DiagramEntry[] = diagramCatalog;

export function buildDiagramCategoryStats(
  diagrams: readonly DiagramEntry[],
): DiagramCategoryStats {
  const counts = new Map<string, number>();
  for (const diagram of diagrams) {
    counts.set(diagram.category, (counts.get(diagram.category) ?? 0) + 1);
  }
  return { categories: Array.from(counts.keys()).sort(), counts };
}

export function filterDiagrams(
  diagrams: readonly DiagramEntry[],
  category: string,
  query: string,
): readonly DiagramEntry[] {
  const needle = query.trim().toLowerCase();
  return diagrams.filter((diagram) => {
    if (category !== "all" && diagram.category !== category) return false;
    if (needle.length === 0) return true;
    return (
      diagram.name.toLowerCase().includes(needle) ||
      diagram.id.toLowerCase().includes(needle)
    );
  });
}
